export default "__VITE_ASSET__C1SOd0gk__"